module.exports = __webpack_public_path__ + "static/about-vig-logo-7a48856dcb095f9c6b77d679a4bf7a47.svg";